import { render, staticRenderFns } from "./liebiao.vue?vue&type=template&id=5690b1df&scoped=true"
import script from "./liebiao.vue?vue&type=script&lang=js"
export * from "./liebiao.vue?vue&type=script&lang=js"
import style0 from "./liebiao.vue?vue&type=style&index=0&id=5690b1df&prod&lang=css"
import style1 from "./liebiao.vue?vue&type=style&index=1&id=5690b1df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5690b1df",
  null
  
)

export default component.exports